export default `
§ sidebar.switch.team: Команда
§ sidebar.switch.person: Сотрудник
§ sidebar.buttons.settings: Настройки
§ sidebar.buttons.print: Печать
§ sidebar.buttons.share: Расшарить
§ sidebar.buttons.logout: Выйти
§ sidebar.filters.all: всё время
§ sidebar.filters.year: год
§ sidebar.filters.halfYear: пол года
§ sidebar.filters.month: месяц
§ sidebar.filters.week: неделя
§ sidebar.team.total: Общая информация
§ sidebar.team.scope: Фичи
§ sidebar.team.author: Сотрудники
§ sidebar.team.type: Типы задач
§ sidebar.team.pr: Влитие кода
§ sidebar.team.day: По дням
§ sidebar.team.week: По неделям
§ sidebar.team.month: По месяцам
§ sidebar.team.files: Файлы
§ sidebar.team.removedFiles: Удалённые файлы
§ sidebar.team.extension: Типы файлов
§ sidebar.team.tasks: Список задач
§ sidebar.team.release: Список релизов
§ sidebar.team.hours: Расписание
§ sidebar.team.commits: Все коммиты
§ sidebar.team.changes: Все изменения
§ sidebar.team.words: Популярные слова
§ sidebar.team.top: Викторина
§ sidebar.team.settings: Настройки
§ sidebar.person.total: Общая информация
§ sidebar.person.money: Стоимость работы
§ sidebar.person.speed: Скорость
§ sidebar.person.day: По дням
§ sidebar.person.week: По неделям
§ sidebar.person.month: По месяцам
§ sidebar.person.hours: Расписание
§ sidebar.person.commits: Все коммиты
§ sidebar.person.changes: Все изменения
§ sidebar.person.words: Популярные слова
§ sidebar.person.settings: Настройки
`;
